import { Module } from "@/services/module";

class PurchaseCache extends Module {
  constructor() {
    super({});
  }
}
export default new PurchaseCache();
